import Dexie from 'dexie';
import { JobDataPoint } from '../../modules/job/models';

export class JobDb extends Dexie {
  jobs: Dexie.Table<JobDataIDB, string>;

  constructor() {
    super('Jobs-v1');
    this.version(1).stores({
      jobs: 'id, jobId'
    });
  }
}

export interface JobDataIDB {
  id: number;
  jobId: number;
  dateCollected: number;
  data: JobDataPoint[];
}

export interface CachedJob {
  jobId: string;
  jobData: JobDataIDB[];
}

export interface CachedJobWithIntervals {
  jobId: number;
  jobDataIntervals: CachedJobCollection[];
}

export interface CachedJobCollection {
  interval: number;
  jobData: JobDataIDB[];
}

export class JobDataIDBResponse {
  rightShiftEnded: boolean = false;
  leftShiftEnded: boolean = false;
  // jobData: JobDataIDB[] = [];
  startDate: number;
  endDate: number;
}

export class JobDataIDBResponseNew {
  rightShiftEnded: boolean = false;
  leftShiftEnded: boolean = false;
  startDate: number;
  endDate: number;
  jobData: JobDataIDB[] = [];
}